import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { slideInAnimation } from './route-animation';
import version from '../../package.json';
import { SystemTypeState } from './store/SystemType/SystemTypeReducer';
import { Store } from '@ngrx/store';
import { SystemTypeEnum } from './model/SystemTypeEnum';
import { initSystemTypeSelector } from './store/SystemType/SystemTypeSelector';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'cw-root',
  templateUrl: './app.component.html',
  animations: [
    slideInAnimation
  ]
})
export class AppComponent implements OnInit {
  title = 'Clearing FX';
  appVersion = version.version;
  systemType: SystemTypeEnum;
  SystemTypeEnum = SystemTypeEnum;

  constructor(private readonly systemTypeStore: Store<SystemTypeState>,
              private readonly titleService: Title,
              private renderer: Renderer2, @Inject(DOCUMENT) private document: Document) {
  }

  ngOnInit(): void {
    this.systemTypeStore.select(initSystemTypeSelector).subscribe((type) => {
      this.systemType = type;
      if (type === SystemTypeEnum.DEMO) {
        this.addClassToHTMLTag('demo-env');
        this.titleService.setTitle('Clearing FX - DEMO')
      }
    });
  }

  addClassToHTMLTag(className: string) {
    const htmlTag = this.document.getElementsByTagName('html')[0];
    this.renderer.addClass(htmlTag, className);
  }


}
